var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import CommonService from "../api/CommonService";
import _ from 'lodash';
var AreaShop = (function (_super) {
    __extends(AreaShop, _super);
    function AreaShop() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.areaList = [];
        _this.shopList = [];
        _this.deliveryShopList = [];
        _this.formData = {};
        return _this;
    }
    AreaShop.prototype.normalizer = function (id, name) {
        if (id === void 0) { id = "id"; }
        if (name === void 0) { name = "name"; }
        return function (node) { return ({
            id: node[id],
            label: node[name],
            children: node.children,
        }); };
    };
    AreaShop.prototype.created = function () {
        this.commonService = CommonService.getInstance();
    };
    AreaShop.prototype.mounted = function () {
    };
    AreaShop.prototype.getArea = function () {
        var _this = this;
        this.commonService.getArea().then(function (res) {
            var area = [res.data.data[0]];
            _this.areaList = [area[0]];
            if (!_this.shopList.length) {
                _this.getShop();
            }
        }).catch(function (err) {
            _this.$message.error(err.message || err.msg);
        });
    };
    AreaShop.prototype.getShop = function () {
        var _this = this;
        this.commonService.getShop({
            area_ids: this.formData.region_id,
            real: "0",
        }).then(function (res) {
            _this.shopList = res.data.data;
            _this.deliveryShopList = _.cloneDeep(_this.shopList);
        }).catch(function (err) {
            _this.$message.error(err.message || err.msg);
        });
    };
    AreaShop.prototype.areaChange = function (value, instanceId) {
        this.formData.region_id = value.id;
        this.formData.shop_id = "";
        this.formData.delivery_order_shop_ids = "";
        this.getShop();
    };
    AreaShop.prototype.resetData = function () {
        this.formData = {
            region_id: "86000000",
            shop_id: null,
            delivery_order_shop_ids: null
        };
    };
    AreaShop.prototype.getFormData = function () {
        return {
            area_ids: this.formData.region_id,
            shop_id: (this.formData.shop_id || []).join(","),
            delivery_order_shop_ids: (this.formData.delivery_order_shop_ids || []).join(","),
        };
    };
    __decorate([
        Prop({
            default: '',
        })
    ], AreaShop.prototype, "type", void 0);
    AreaShop = __decorate([
        Component
    ], AreaShop);
    return AreaShop;
}(Vue));
export default AreaShop;
